import React, { useState, useEffect } from "react";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormOtherDetails from "../../../../components/common/forms/FormOtherDetails";
import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import {
  Pan_Registration_v3,
  Vat_upload_details_v2,
  Pan_Reg_details_of_shareholder,
  Vat_details_of_shareholder,
  pan_shareholder,
  vat_shareholder,
  Pan_Registration_v2,
  Vat_upload_details,
} from "../VatRegistrationForm";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import FormPayment from "../../../../components/common/forms/FormPayment";
import Documents from "../../../../components/common/forms/Documents";
import api from "../../../../api/api";
import { toast } from "react-toastify";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import VatRegistrationA from "../VatRegistration/VatRegistration";
import BackButton from "../../../../components/common/backbutton/BackButton";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";
import { useSelector } from "react-redux";


const VatRegistrationB = () => {
  const { register, handleSubmit, unregister } = useForm();
  const [shareHolders, setShareHolders] = useState([
    {
      ...pan_shareholder,
      id: uuidv4(),
    },
  ]);

  const [uploadProof, setUploadProof] = useState('')

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)


  const [docsOutput, setDocsOutput] = useState([]);
  const [fieldChnage, setFieldChnage] = useState(true);
  const [changeForm, setChangeForm] = useState(true);

  const [paymentRangeList, setPaymentList] = useState([]);
  const [amount, setAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);
  const [registrationNature, setRegistrationNature]  = useState(null)


    // For amount calculation
    useEffect(() => {

      if(registrationNature) {
         let arr = paymentRangeList.filter((item)=> {
         return item.registration_nature === registrationNature
        })
        setAmount(arr[0].amount)
      }      

  }, [registrationNature])


 // getting current user
  useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.due_amount);
      })
      .catch((error) => {});
  }, []);


    // for filtering by company_type and show in Modal
    useEffect(() => {
      api
        .get(
          "/services/company/registration/service-charges/?company_type=pan_vat_prali"
        )
        .then((response) => {
          // console.log(response.data)
          setPaymentList(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }, []);






  useEffect(() => {
    if(fieldChnage){
      Pan_Registration_v3.map((item)=> {
        unregister(item.name)
      })
    }else{
      Pan_Registration_v2.map((item)=> {
        unregister(item.name)
      })
    }
    
  }, [unregister, fieldChnage])
  



  const handleClick = (data) => {
    data.company_type = "pan_vat_gharelu_ward";
    data.share_holders = shareHolders;
    data.documents = docsOutput;
    // console.log(data)

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

  

    api
      .post("/services/company/", data)
      .then((response) => {
        toast.success("Data Registered successfully");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof : uploadProof,
          company : response.data.company_id,
          transaction_type: "credit"
       
        };
        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((error) => {
        toast.error("Data Registration Failed");
      });
  };

  let data = [];
  Vat_upload_details_v2.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  const ekal = () => {
    setFieldChnage(true);
  };
  const bahul = () => {
    setFieldChnage(false);
  };
  const formChangeA = () => {
    setChangeForm(true);
  };
  const formChangeB = () => {
    setChangeForm(false);
  };

  return (
    <div className="px-10 lg:!px-14">
      <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
        PAN/VAT Registration
      </p>
      <div className=" w-full flex flex-wrap gap-5 my-3 text-center justify-center">
        <div
          onClick={formChangeA}
          className={` ${
            changeForm === true ? "bg-primary-blue  text-white" : "bg-gray-300 text-primary-blue"
          } px-3  py-2 cursor-pointer rounded-2xl font-bold`}
        >
          घरेलु वा वडा कार्यलयमा दर्ता भएको ब्यवसायको पान दर्ताको लागि
        </div>
        <div
          onClick={formChangeB}
          className={` ${
            changeForm === false ? "bg-primary-blue  text-white" : "bg-gray-300 text-primary-blue"
          } px-3  py-2 cursor-pointer rounded-2xl font-bold`}
        >
          प्रा. लि. कम्पनीलाई वडामा दर्ता गर्नको लागि
        </div>
      </div>

      {changeForm === true ? (
        <>
          <form>
          <div className="mt-3">
          {

           (user?.user_type === "ST" || user?.user_type === "AD")
            && <AdminSearchCustomer 
             setUserId={setUserId}
            /> 
          }
         </div>


            <div className="flex justify-between my-3">
              <p className="text-primary-blue fot-Calistoga text-lg underline">
                1. Business Name & Other Details
              </p>
              <p className="text-primary-red flex">
                Firm No.
                <span className=" text-primary-blue"> 1234</span>
              </p>
            </div>

            <div className="flex flex-wrap w-full">
              <div className="w-full border-2 border-primary-blue mt-3">
                <div className="flex md:flex-row flex-col ">
                  <div className="border-primary-blue text-center text-primary-red border-b md:border-r  px-10 py-2 md:w-[30rem]  text-lg font-bold">
                    कम्पनीको नाम
                  </div>

                  <div className="border-primary-blue flex text-primary-red border-b md:border-r px-5 py-2 w-full text-base font-bold sm:text-lg">
                    <p>नेपालीमा: </p>
                    <input
                      className="outline-none w-36 md:w-full  text-primary-blue pl-3 "
                      {...register(`company_name_nep`, {
                        // required: false,
                      })}
                    />
                  </div>
                  <div className="border-primary-blue flex text-primary-red border-b md:border-r px-5 py-2 w-full text-base font-bold sm:text-lg">
                    <p>Englishमा: </p>
                    <input
                      className="outline-none w-36 md:w-full text-primary-blue pl-3 "
                      {...register(`company_name`, {
                        // required: false,
                      })}
                    />
                  </div>
                </div>
                <div className="flex flex-col md:flex-row w-full">
                  <div className="border-primary-blue text-center text-primary-red border-b md:border-r px-5 py-2 sm:!w-[280px] text-lg font-bold">
                    कम्पनीको ठेगाना
                  </div>
                  <div className="border-primary-blue flex text-primary-red border-b p-2 w-full text-base font-bold sm:text-lg">
                    <input
                      className="outline-none w-full text-primary-blue pl-3 "
                      {...register(`company_address`, {
                        // required: false,
                      })}
                    />
                  </div>
                </div>
                <div className="flex flex-col md:flex-row w-full">
                  <div className="border-primary-blue  text-primary-red md:border-r md:border-b-0 border-b md:border-b-0 md:border-r  text-center px-5 py-2 md:w-[32.9rem] text-lg font-bold">
                    ब्यवसायको प्रकार
                  </div>
                  <div className="flex flex-wrap border-primary-blue py-1 gap-3 justify-center items-center text-primary-red md:border-r md:border-b md:p-0  text-base  sm:text-lg">
                    <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  px-3 py-0 text-white">
                      <label htmlFor="ekal" onClick={ekal}>
                        एकल{" "}
                      </label>
                      <input
                        type="radio"
                        name="radio-btn"
                        id="ekal"
                        value="ekal"
                        {...register("business_type", { required: false })}
                      />
                    </div>

                    <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  px-3 py-0 text-white">
                      <label htmlFor="bahul" onClick={bahul}>
                        साझेदारी
                      </label>
                      <input
                        type="radio"
                        name="radio-btn"
                        value="bahul"
                        id="bahul"
                        {...register("business_type", { required: false })}
                      />
                    </div>
                    {/* <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                  <label htmlFor="prali" >प्रा.लि. कम्पनी</label>
                  <input type="radio" name="radio-btn" 
                 
                  id="prali"
                   {...register("business_type", { required: false, })}
                   />
                </div> */}
                    {/* <div className="rounded-xl bg-red-600 px-3 py-1 text-white">
                test
                </div> */}
                  </div>
                  <div className="flex flex-col md:flex-row border-primary-blue text-primary-red  gap-3 pl-5 w-full items-center text-base font-bold sm:text-lg">
                    दर्ता गर्ने प्रकृती:
                    <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  px-3 py-0 text-white">
                      <label htmlFor="pan" className="text-sm font">
                        {" "}
                        ONLY PAN{" "}
                      </label>
                      <input
                        type="radio"
                        name="radio-btn"
                        value="pan"
                        className="bg-yellow"
                        {...register("registration_nature", { required: false,
                         onChange: (e) => {setRegistrationNature(e.target.value)}
                          
                        })}
                        id="pan"
                      />
                    </div>
                    <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  px-3 py-0 text-white">
                      <label htmlFor="pan&vat" className="text-sm font">
                        {" "}
                        PAN & VAT
                      </label>
                      <input
                        type="radio"
                        name="radio-btn"
                        value="pan_vat"
                         {...register("registration_nature", { required: false,
                          onChange : (e) => {setRegistrationNature(e.target.value)}
                        })}
                        id="pan&vat"
                      />
                    </div>
                    <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  px-3 py-0 text-white">
                      <label htmlFor="pve" className="text-sm font">
                        PAN VAT & Excise
                      </label>
                      <input
                        type="radio"
                        name="radio-btn"
                        value="pan_vat_excise"
                         {...register("registration_nature", { required: false,
                          onChange : (e) => {setRegistrationNature(e.target.value)}
                        })}
                        id="pve"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full flex gap-1 md:flex-row flex-col items-center">
              {fieldChnage === true ? (
                <>
                  <div className="mt-4 border-2 border-primary-blue w-full">
                    <div>
                      {/* <div> */}
                      {Pan_Registration_v2.map((item, i) => {
                        const { name, validation, ip1, type } = item;
                        return (
                       
                            <div
                              key={i}
                              className=" border-primary-blue flex flex-col  md:flex-row  "
                            >
                              <div className="text-primary-red font-Laila border-b text-center border-primary-blue px-5 py-2 sm:!w-[350px] font-bold">
                                {ip1}
                              </div>
                              <div className="md:border-l-2 border-b border-primary-blue text-primary-red  px-10 text-lg font-bold">
                                <input
                                  type={type}
                                  className=" w-full py-2 outline-none "
                                  {...register(`${name}`, { required: false })}
                                />
                              </div>
                            </div>
                        
                        );
                      })}

                      {/* </div> */}
                    </div>
                    <div className="bg-red-200 border-spacing-2 border-primary-blue  border-t text-primary-blue font-bold  py-2 font-Laila text-center">
                      <div className="p-3">
                        पुँजी र प्रकृतीको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
                        <span className="text-red-600">रु.{amount}।– </span> मात्र
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="mt-4 border-2 border-primary-blue w-full">
                    <div>
                      {/* <div> */}
                      {Pan_Registration_v3.map((item, i) => {
                        const { name, validation, ip1, type } = item;
                        return (
                        
                            <div
                              key={i}
                              className=" border-primary-blue flex flex-col md:flex-row  "
                            >
                              <div className="text-primary-red font-Laila border-b border-primary-blue px-1 py-2 text-center sm:!w-[360px] font-bold">
                                {ip1}
                              </div>
                              <div className="md:border-l-2 border-primary-blue text-primary-red border-b px-10 text-lg font-bold">
                                <input
                                  type={type}
                                  className=" w-full py-2 outline-none "
                                  {...register(`${name}`, { required: false })}
                                />
                              </div>
                            </div>
                         
                        );
                      })}

                      {/* </div> */}
                    </div>
                    <div className="bg-red-200 border-spacing-2 border-primary-blue  border-t font-Laila text-primary-blue font-bold  py-2 text-center">
                      साझेदारहरुको संख्या, ब्यवसायको प्रकृति र पुँजीको तपाईको
                      जम्मा लाग्ने रकम{" "}
                      <span className="text-red-600">रु.{amount}– </span> मात्र
                    </div>
                  </div>
                </>
              )}

              <div>
                <div>
                  <div className="border-primary-red font-Laila text-center text-primary-blue w-fit rounded-full border-2 p-2 text-sm md:text-base">
                    घरेलु वा वडा कार्यालय मार्फत दर्ता भएको ब्यवसाय पान, भ्याट
                    निकाल्दा लाग्ने शुल्क सम्बन्धि पूर्ण जानकारी लिनको लागि यहाँ <span
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalEdit"
                      className="text-primary-red cursor-pointer"
                    >   Click
                    </span> गर्नुहोस ।
                    <PrivateCompanyModal paymentRangeList={paymentRangeList} />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="mt-4">
          <div>
            <div>
              {Pan_Registration_v3.map((item, i) => {
                const { name, validation, ip1, type } = item;
                console.log(item);
                return (
                  <div
                    key={i}
                    className="border-primary-blue flex flex-col md:flex-row"
                  >
                    <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      {ip1}
                    </div>
                    <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                      <input className="outline-none text-primary-blue pl-2" type={type} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div> */}

            <div className="text-primary-blue font-Calistoga  my-3 underline">
              2. Details of Share Holders
              <span className="text-primary-blue font-Laila underline">
                (कम्पनी दर्ता गर्दा रहेका शेयर सदस्यहरुको विवरण अनिवार्य
                भर्नुपर्नेछ ।)
              </span>
            </div>
            {/* share holder details form */}
            {/* <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
              <div className="min-w-[1300px] overflow-x-auto">
                <div id="tbl_posts">
                  <div>
                    <div>
                      <div className="border-primary-blue  text-primary-red border text-lg font-bold">
                        क्र. स.
                      </div>
                      <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                        साझेदार सदस्यहरुको नाम
                      </div>
                      <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                        हालको ठेगाना
                      </div>

                      <div className="border-primary-blue text-primary-red border border-r-0 text-base font-bold sm:text-lg">
                        शेयर सदस्यको नागरिकता
                      </div>
                      <div className="border-primary-blue text-primary-red border border-r text-base font-bold sm:text-lg">
                        कैफियत
                      </div>
                    </div>
                  </div>
                  <div id="tbl_posts_body">
                    <div id="rec-1" className="border-primary-blue border">
                      <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                        1
                      </div>
                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="file"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>

                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </div>
                    </div>
                  </div>
                </div> */}
            <div style={{ display: "none" }}>
              {/* div row add */}
              <div id="sample_table">
                <div>
                  <div id="" className="border-primary-blue border">
                    <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                      <span className="sn">1</span>
                    </div>
                    <div className="p-0">
                      <input
                        type="text"
                        name=""
                        className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                        id=""
                      />
                    </div>
                    <div className="p-0">
                      <input
                        type="text"
                        name=""
                        className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                        id=""
                      />
                    </div>
                    <div className="p-0">
                      <input
                        type="text"
                        name=""
                        className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                        id=""
                      />
                    </div>
                    <div className="p-0">
                      <input
                        type="file"
                        name=""
                        className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                        id=""
                      />
                    </div>
                    <div className="p-0">
                      <input
                        type="text"
                        name=""
                        className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                        id=""
                      />
                    </div>
                    <div className="p-0">
                      <input
                        type="text"
                        name=""
                        className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                        id=""
                      />
                    </div>
                    <div className="p-0">
                      <input
                        type="file"
                        name=""
                        className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                        id=""
                      />
                    </div>
                    <div className="">
                      <a href="" className="delete-record">
                        <svg
                          className="text-primary-red h-8 w-8"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="img"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M19.1 4.9C15.2 1 8.8 1 4.9 4.9S1 15.2 4.9 19.1s10.2 3.9 14.1 0s4-10.3.1-14.2zm-4.3 11.3L12 13.4l-2.8 2.8l-1.4-1.4l2.8-2.8l-2.8-2.8l1.4-1.4l2.8 2.8l2.8-2.8l1.4 1.4l-2.8 2.8l2.8 2.8l-1.4 1.4z"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* </div>
            </div>
          </div>
        </div> */}

            <DetailsOfShareHolders
              DetailShareholder={Vat_details_of_shareholder}
              needed_share={vat_shareholder}
              setShareHolders={setShareHolders}
              shareHolders={shareHolders}
            />

            {/* details of share holders close */}
            <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
              3. Main Objective
              <span className="text-primary-blue font-Laila underline">
                (पान प्रमाण पत्रमा देखिने गरी राख्नुपर्ने मुख्य मुख्य कामहरु
                सहितको उद्देश्यहरु यहाँ लेख्नुहोस्)
              </span>
            </div>
            <MainObjectives register={register} />

            {/* upload documents open */}
            <p className="text-primary-blue font-Calistoga  text-lg  my-3 underline">
              4.Document Upload{" "}
              <span className="text-primary-blue font-Laila">
                {" "}
                (यो पान, भ्याटमा दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु{" "} <span className="text-red-600"> Upload</span> गर्नुहोस ।)
              </span>
            </p>
            <Documents
              documents_data={Vat_upload_details}
              initialState={data}
              setDocument={setDocsOutput}
            />

            {/* <div>
          <div>
            <div>
              <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                S. N.
              </div>
              <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Document Name
              </div>
              <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Action
              </div>
              <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                Remarks
              </div>
            </div>
          </div>
          <div>
            {Vat_upload_details_v2.map((item, index) => {
              return (
                <div className="border-primary-blue border" key={index}>
                  <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                    {item.sn}
                  </div>
                  <div className="p-0">
                    <p className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none">
                      {item.ip1}
                      <button className="bg-primary-blue text-white rounded-xl ml-3 px-2">
                        Upload
                      </button>
                    </p>
                  </div>
                  <div className="p-0">
                    <div className="border-primary-blue text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                      <button className="bg-primary-green rounded-xl px-2 ">
                        view
                      </button>
                      <button className="bg-primary-red rounded-xl px-2">
                        Delete
                      </button>
                    </div>
                  </div>
                  <div className="p-0">
                    <div className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                      {item.remark}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}
            {/* upload documents close */}
            <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
              5. Working Branch <span className="text-primary-blue font-Laila underline"> (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन
                शाखा नजिक पर्छ छनोट गर्नुहोस् ।){" "}
              </span>
            </div>
            <FormBranch register={register} />
            <FormButtom />
            <FormPayment
              handleSubmit={handleSubmit}
              handleClick={handleClick}
              setUploadProof={setUploadProof}
              dueAmount = {dueAmount}
              setPaidAmount = {setPaidAmount}
              totalAmount={amount}

            />
          </form>
        </>
      ) : (
        <>
          {/* <VatRegistrationA/>
           */}
          <div>
            <VatRegistrationA />
          </div>
        </>
      )}
    </div>
  );
};
export default VatRegistrationB;
